import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser, signOut } from 'aws-amplify/auth';

function AppealHistory() {
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      const user = await getCurrentUser();
      const response = await fetch(`https://clinixai.net/get-appeals/${user.userId}`);
      const data = await response.json();
      setHistory(data.appeals || []);
    } catch (error) {
      console.log('Error fetching history:', error);
    }
    setLoading(false);
  };

  const handleLogout = async () => {
    await signOut();
    navigate('/login');
  };

  const filteredHistory = history.filter((item) =>
    item.patient_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const statusColors = {
    pending: { bg: '#fef3c7', text: '#92400e' },
    approved: { bg: '#d1fae5', text: '#065f46' },
    denied: { bg: '#fee2e2', text: '#991b1b' },
  };

  return (
    <div style={{
      fontFamily: 'Arial, sans-serif',
      maxWidth: '900px',
      margin: '0 auto',
      padding: '20px'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '30px',
        borderBottom: '2px solid #1a365d',
        paddingBottom: '15px'
      }}>
        <h1 style={{ color: '#1a365d', margin: 0 }}>Clinix AI</h1>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={() => navigate('/appeal')}
            style={{
              padding: '8px 16px',
              backgroundColor: '#edf2f7',
              color: '#1a365d',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            New Appeal
          </button>
          <button
            onClick={handleLogout}
            style={{
              padding: '8px 16px',
              backgroundColor: '#e53e3e',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            Logout
          </button>
        </div>
      </div>

      <h2 style={{ color: '#2d3748', marginBottom: '20px' }}>
        Past Appeals ({filteredHistory.length})
      </h2>

      <input
        type="text"
        placeholder="Search by patient name..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          width: '100%',
          padding: '10px',
          marginBottom: '16px',
          borderRadius: '6px',
          border: '1px solid #ddd',
          fontSize: '14px',
          boxSizing: 'border-box'
        }}
      />

      <div style={{
        backgroundColor: 'white',
        padding: '24px',
        borderRadius: '10px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      }}>
        {loading ? (
          <p style={{ color: '#718096' }}>Loading...</p>
        ) : filteredHistory.length === 0 ? (
          <p style={{ color: '#718096' }}>
            {history.length === 0
              ? 'No appeals yet. Generate your first appeal above.'
              : 'No patients match your search.'}
          </p>
        ) : (
          filteredHistory.map((item) => (
            <div
              key={item.id}
              style={{
                padding: '14px',
                borderBottom: '1px solid #e2e8f0',
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <strong
                  onClick={() => navigate(`/appeal-detail/${item.id}`)}
                  style={{ color: '#1a365d', cursor: 'pointer', textDecoration: 'underline' }}
                >
                  {item.patient_name}
                </strong>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{
                    padding: '2px 10px',
                    borderRadius: '10px',
                    fontSize: '12px',
                    backgroundColor: statusColors[item.status]?.bg || '#f0f0f0',
                    color: statusColors[item.status]?.text || '#333',
                    textTransform: 'capitalize'
                  }}>
                    {item.status || 'pending'}
                  </span>
                  <span style={{ color: '#718096', fontSize: '13px' }}>
                    {new Date(item.created_at).toLocaleString()}
                  </span>
                </div>
              </div>
              <p style={{ color: '#4a5568', fontSize: '14px', margin: '4px 0' }}>
                {item.requested_medication} — {item.diagnosis}
              </p>
              <button
                onClick={() => navigator.clipboard.writeText(item.appeal_letter)}
                style={{
                  padding: '4px 10px',
                  backgroundColor: '#edf2f7',
                  color: '#1a365d',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '13px'
                }}
              >
                Copy Appeal
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default AppealHistory;
